const BASE = process.env.REACT_APP_BACKEND_URL || import.meta?.env?.REACT_APP_BACKEND_URL;
const API = () => {
  if (!BASE) throw new Error("Backend URL is not configured");
  return `${BASE}/api`;
};

export async function initUpload({ filename, size, mime }) {
  const res = await fetch(`${API()}/knowledge/upload/init`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ filename, size, mime })
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function uploadChunk({ uploadId, index, total, blob }) {
  const fd = new FormData();
  fd.append('upload_id', uploadId);
  fd.append('index', String(index));
  fd.append('total', String(total));
  fd.append('chunk', new File([blob], `chunk-${index}`));
  const res = await fetch(`${API()}/knowledge/upload/chunk`, { method: 'POST', body: fd });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function completeUpload({ uploadId }) {
  const fd = new FormData();
  fd.append('upload_id', uploadId);
  const res = await fetch(`${API()}/knowledge/upload/complete`, { method: 'POST', body: fd });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function listDocs() {
  const res = await fetch(`${API()}/knowledge/docs`);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function askDocs(question) {
  const res = await fetch(`${API()}/knowledge/query`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ question })
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function lpReasons({ deal_name, stage, sector, notes }) {
  const res = await fetch(`${API()}/lp/reasons`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ deal_name, stage, sector, notes })
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export async function platformInsights(payload) {
  const res = await fetch(`${API()}/platform/insights`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}